import { CreateForm } from "./CreateForm";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { useTranslation } from "react-i18next";
import { AdminCategoryDownloadService } from "../../downloadCategory/service";
import { useNavigate } from "react-router-dom";
import { IPage } from "../interface";
import { AdminPageService } from "../service";
export const CreatePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [state, setState] = useState<IPage>({
    title: "",
    text: "",
    category: { name: "" },
  });

  const submitHandler = () => {
    AdminPageService.create(state)
      .then((response) => {
        SuccessToast(t(`settings.successfully_saved`));
        navigate("/admin/page");
      })
      .catch((error) => ErrorToast(error));
  };

  return (
    <div className="col-12">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          submitHandler();
        }}
      >
        <CreateForm categories={categories} state={state} setState={setState} />
      </Form>
    </div>
  );
};
